import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton } from '@mui/material';
import { FC, memo } from 'react';

export type TableRowAction = {
    icon: JSX.Element;
    onClick: (id: string) => void;
    dataTestId?: string;
};

type RowActionsProps = {
    id: string;
    enableDelete: boolean;
    customActions?: TableRowAction[];
    handleDeleteRow: (id: string) => void;
    handleEditRow: (id: string) => void;
};

const RowActions: FC<RowActionsProps> = ({ id, handleDeleteRow, handleEditRow, enableDelete, customActions }) => {
    return (
        <Box>
            {enableDelete && (
                <IconButton data-testid="delete-action" onClick={() => handleDeleteRow(id)}>
                    <DeleteIcon />
                </IconButton>
            )}
            <IconButton data-testid="edit-action" onClick={() => handleEditRow(id)}>
                <EditIcon />
            </IconButton>
            {customActions?.map((action, index) => (
                <IconButton key={index} data-testid={action.dataTestId} onClick={() => action.onClick(id)}>
                    {action.icon}
                </IconButton>
            ))}
        </Box>
    );
};

export default memo(RowActions);
